import { useQuery } from '@zg-rentals/react-query5';
import { type AdTagsAttributes, type AdTagsRequest, fetchAdTags } from '@/src/lib/api/endpoints/analytics';

export const adTagsKeys = {
  all: ['adTags'] as const,
  byBoundingBox: (request: AdTagsRequest | null) => [...adTagsKeys.all, request] as const,
};

/**
 * GAM targeting keys for the searched bounding box. Pass `null` to skip the
 * fetch (no bounds yet, or no ad slots on the page).
 */
export const useAdTags = (request: AdTagsRequest | null) => {
  return useQuery<AdTagsAttributes>({
    queryKey: adTagsKeys.byBoundingBox(request),
    queryFn: ({ signal }) => {
      if (!request) throw new Error('useAdTags requires a bounding box');
      return fetchAdTags(request, signal);
    },
    enabled: request !== null,
    staleTime: 5 * 60 * 1000,
    retry: false,
    meta: {
      tags: ['adTags'],
      context: { api: 'hotpads-api', details: 'GET /v2/analytics/adtags for SRP GAM targeting' },
    },
  });
};
